var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showContact === 1 && _vm.isShow && false
    ? _c(
        "div",
        { staticClass: "contacts" },
        [
          _c(
            "el-row",
            {
              staticClass: "main",
              staticStyle: { "max-width": "1200px", margin: "0 auto" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 9 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", align: "middle" } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("img", { attrs: { src: "/images/jzq-gzh.png" } })
                      ]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "30px" },
                          attrs: { span: 16 }
                        },
                        [
                          _c("p", { staticClass: "text" }, [
                            _c("i", {
                              staticClass: "icon icon-wx-w",
                              staticStyle: {
                                width: "18px",
                                height: "16px",
                                "margin-right": "10px"
                              }
                            }),
                            _c("span", { staticClass: "tl" }, [
                              _vm._v("关注微信公众号")
                            ])
                          ]),
                          _c("p", { staticClass: "text" }, [
                            _vm._v(
                              "锁定君子签最新资讯，还可在公众号上快速签署文件"
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 9 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", align: "middle" } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("img", { attrs: { src: "/images/jzq-xcx.png" } })
                      ]),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "30px" },
                          attrs: { span: 16 }
                        },
                        [
                          _c("p", { staticClass: "text" }, [
                            _c("i", {
                              staticClass: "icon icon-xcx-w",
                              staticStyle: {
                                width: "18px",
                                height: "18px",
                                "margin-right": "10px"
                              }
                            }),
                            _c("span", { staticClass: "tl" }, [
                              _vm._v("收藏微信小程序")
                            ])
                          ]),
                          _c("p", { staticClass: "text" }, [
                            _vm._v("使用微信扫一扫添加小程序，文件签署更方便")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", align: "top" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "align-items": "flex-start"
                          },
                          attrs: { span: 8 }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "60px", height: "20px" },
                                attrs: {
                                  src: require("../../static/images/web/jzqlogo.png"),
                                  alt: "君子签"
                                }
                              }),
                              _vm._v("    |\n          ")
                            ]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "60px", height: "20px" },
                                attrs: {
                                  src: require("../../static/images/web/ebqlogo.png"),
                                  alt: "易保全"
                                }
                              }),
                              _vm._v("    |\n          ")
                            ]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c("img", {
                                staticStyle: { width: "60px", height: "20px" },
                                attrs: {
                                  src: require("../../static/images/web/wbqlogo.png"),
                                  alt: "微版权"
                                }
                              }),
                              _vm._v("    |\n          ")
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "80px",
                                height: "20px",
                                display: "flex",
                                "justify-content": "flex-end",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "12px",
                                  height: "12px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  src: require("../../static/images/web/phone.png")
                                }
                              }),
                              _vm._v("电话    |\n          ")
                            ]
                          )
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "align-items": "flex-start",
                            "justify-content": "space-between"
                          },
                          attrs: { span: 16 }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                height: "20px",
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.junziqian.com",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("君子签官网")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                height: "20px",
                                "line-height": "20px"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      _vm.globalConfig.domain.forensicsWebOp,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("电子数据保全中心")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                height: "20px",
                                "line-height": "20px"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.globalConfig.domain.athenaWebUms,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("知识产权保护平台")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                height: "20px",
                                "line-height": "20px",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("\n            400-808-9187\n          ")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ea97711", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea97711","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/contacts/index.vue
// module id = UU+X
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37